import "./style.css";

export default class Article {
  static selector = ".article";
  constructor(block) {
    this.block = block;

    //this.side = this.block.querySelector(".article__side");

    //this.articleBackground = block.querySelector(
    //  ".article__featured_image--large"
    //);
    //this.setupArticleBackground();
  }

  /*
  setupArticleBackground = () => {
    const backgroundUrl = this.articleBackground.dataset.url;
    let image = new Image();
    image.onload = this.backgroundImageLoded;
    image.src = backgroundUrl;
  };

  backgroundImageLoded = e => {
    this.articleBackground.style.backgroundImage =
      "url('" + e.currentTarget.src + "')";
    this.articleBackground.classList.add(
      "article__featured_image--large--loaded"
    );
  };
  */
}
